import axios from "axios";
import ApiRoutes from "./apiRoutes";

const api = axios.create({
  baseURL: ApiRoutes.baseUrl,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

api.interceptors.request.use((config) => {

  return config;
});

api.interceptors.response.use(
  function (response) {
    const responseStatus = response.data?.payload?.statusCode;


    if (
      responseStatus === 200 ||
      responseStatus === 201 ||
      responseStatus === null
    ) {
      return response;
    }
    console.log(responseStatus);
    return Promise.reject(response.data?.payload?.statusMessage);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

// apiDirect is exported without touching the data as it comes in
const apiDirect = axios.create({
  baseURL: ApiRoutes.baseUrl,
  // baseURL: "https://nlp.tedif.com/api/",
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

apiDirect.interceptors.request.use((config) => {
  console.log(config);
  return config;
});

apiDirect.interceptors.response.use(
  function (response) {
    const responseStatus = response.data?.statusCode;
    console.log(response);
    console.log(responseStatus);

    if (
      responseStatus === 200 ||
      responseStatus === 201 ||
      responseStatus === null
    ) {
      return response;
    }
    console.log(responseStatus);
    return Promise.reject(response.data);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { apiDirect };

// data:
// {id: '53ec215c-15d0-1544-4747-3a10dac3f4c1', blockedBalance: 0, availableBalance: 0, ledgerBalance: 0, email: 'progfams@gmail.com', …}
// statusCode:
// 200
// statusMessage:
// 'Successful'
